import { Fragment, useState } from 'react';
import { FullScreenLoader, Grid, useSnack } from 'enova-frontend-components';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getHasErrors } from '../../../../components/registering/utils/validation';
import { AllRegistrationScreenParams, RegistrationCommonStep } from '../../../../utils/navigation';
import useStore from '../../../../hooks/useStore';
import { createErrorMessage } from '../../../../utils/utils';
import { usePublishRegistration } from '../../../../hooks/usePublishRegistration';
import ErrorMessage from '../errorMessage';
import { NextStepButton, PreviousStepButton } from '../registrationActionButtons/buttons';
import useRegistrationForm from '../../useRegistrationForm';

export const SummaryButtons = () => {
  const store = useStore();
  const { buildingId } = useParams<AllRegistrationScreenParams>();

  const [hasErrors, setHasErrors] = useState(false);
  const navigate = useNavigate();
  const { addSnack } = useSnack();
  const { t } = useTranslation();
  const { prevStep, registrationId } = useRegistrationForm();
  const { publishRegistration, publishIsLoading } = usePublishRegistration(registrationId, buildingId);

  const showErrorMessage = () => {
    addSnack(
      createErrorMessage(
        t('registerScreen.saveRegistration.saveFailed', {
          context: 'publish'
        })
      ),
      { variant: 'error' }
    );
  };

  const onPublish = () => {
    if (getHasErrors(store.getState(), RegistrationCommonStep.SUMMARY)) {
      setHasErrors(true);

      return;
    }

    publishRegistration(undefined, {
      onSuccess: () => navigate(`../../${RegistrationCommonStep.ENERGY_CERTIFICATE}`),
      onError: () => showErrorMessage()
    });
  };

  return (
    <Fragment>
      <FullScreenLoader open={publishIsLoading} />

      {hasErrors && (
        <Grid item xs={12} mt={10}>
          <ErrorMessage />
        </Grid>
      )}

      <Grid item xs={12} container spacing={4} mt={10} direction={{ xs: 'column', sm: 'row' }}>
        <Grid flex={1} item sm="auto" xs={12}>
          <PreviousStepButton disabled={publishIsLoading} onClick={() => navigate(`../../${prevStep}`)} />
        </Grid>

        <Grid flex={1} item sm="auto" ml={{ sm: 'auto' }} xs={12}>
          <NextStepButton onClick={onPublish} disabled={hasErrors || publishIsLoading} />
        </Grid>
      </Grid>
    </Fragment>
  );
};
